import { Component, ViewChild, OnInit, SimpleChanges } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { TranslateService } from '@ngx-translate/core';
import { Config, Nav, Platform, App, Events, NavController } from 'ionic-angular';
import { FirstRunPage } from '../pages/pages';
import { Settings, User } from '../providers/providers';
import { UserType, CurrentUser } from '../models/user.model';

import { PrizeGameProvider } from './../providers/prize-game/prize-game';
import { Storage } from '@ionic/storage';
import { WebSocketProvider } from './../providers/web-socket/web-socket';
import { WebPushProvider } from './../providers/web-push/web-push';
import { GeoFenceProvider } from './../providers/geo-fence/geo-fence';
import { Deeplinks } from "@ionic-native/deeplinks";
import { RedirectPage } from "../pages/redirect/redirect";
import { HomePage } from '../pages/home/home';
import { EventInfoProvider } from '../providers/event-info/event-info';

@Component({
    template: `<ion-menu [content]="content" (ionOpen)="loadCurrentUser()">
    <ion-header no-border>
      <ion-toolbar>
      <div class="profile-menu" menuClose (click)="openProfile()">
      <div class="profile-info user-avatar" *ngIf="getCurrentUser">
        <img class="profile-image" [src]="getCurrentUser.pictureUrl"  onError="this.src='./assets/img/80x80.png'">
        </div>
        <div class="profile-info" *ngIf="getCurrentUser">
          <h2>{{   getCurrentUser.firstName    }} {{getCurrentUser.lastName}}</h2>
          <p class="user-title">{{getCurrentUser.title}}</p>
          <p class="user-company">{{getCurrentUser.company}}</p>
        </div>
        <img *ngIf="getCurrentUser" class="profile-background" [src]="getCurrentUser.pictureUrl" onError="this.src='./assets/img/80x80.png'">
      </div>
      </ion-toolbar>
    </ion-header>

    <ion-content>
    <div class="divider"></div>
      <ion-list no-lines>
        <button menuClose ion-item *ngFor="let p of pages" (click)="openPage(p)">
          <i class="sidebar-icon {{p.icon}}" aria-label="My icon"></i> {{p.title}}
        </button>
      </ion-list>
      <hr  *ngIf='isAdmin'>
      <ion-list *ngIf='isAdmin' no-lines>
        <button  menuClose ion-item (click)="prizeGameController()">
        <i class="sidebar-icon im-icon_prize-game" aria-label="My icon"></i> Prize Game Controller
        </button>
      </ion-list>
      <hr *ngIf='isAdmin'>
      <ion-list no-lines>
        <button menuClose ion-item (click)=" logOut();">
        <i class="sidebar-icon im-icon_log-out" aria-label="My icon"></i> Logout
        </button>
      </ion-list>
      <hr  *ngIf="!platform.is('cordova')">
      <ion-list *ngIf="!platform.is('cordova')" no-lines>
        <a  menuClose ion-item href="https://dev.matchabout.com/admin" target="_blank">
        <i class="sidebar-icon im-event-navigation_info" aria-label="My icon"></i> Manage Events
        </a>
      </ion-list>
      <ion-list no-lines>
        <a class="contact-dev" href="mailto:matchabout@puzzlesoftware.rs"> Contact @matchabout </a>
      </ion-list>
    </ion-content>

  </ion-menu>
  <ion-nav #content [root]="rootPage"></ion-nav>`,
})
export class MyApp implements OnInit {
    rootPage = FirstRunPage;
    currentUser: CurrentUser;
    isAdmin: boolean = false;
    @ViewChild(Nav)
    nav: Nav;

    pages: any[] = [
        {
            title: 'Events List',
            icon: 'im-icon_event',
            component: 'HomePage',
            param: 1,
            root: true
        },
        {
            title: 'My Profile',
            icon: 'im-icon_profile',
            component: 'ProfileSettingsPage',
            param: 1,
            root: false
        },
        {
            title: 'My Contacts',
            icon: 'im-icon_contacts',
            component: 'MessengerPage',
            param: 'contacts',
            root: false
        },
        {
            title: 'Messages',
            icon: 'im-icon_message-notification',
            component: 'MessengerPage',
            param: 'messages',
            root: false
        },
        {
            title: 'My Notes',
            icon: 'im-icon_notes',
            component: 'MessengerPage',
            param: 'notes',
            root: false
        },
        {
            title: 'My Documents',
            icon: 'im-icon_notes',
            component: 'MyDocumentsPage',
            param: 'documents',
            root: false
        },
        // {
        //     title: 'QR Reader',
        //     icon: 'im-icon_qr',
        //     component: 'QrCodeReaderPage',
        //     param: 'documents',
        //     root: false
        // },
        /*{
          title: 'Event Feeds',
          icon: 'newspaper',
          component: 'HomePage',
          param: 1,
        },
        {
          title: 'My Events',
          icon: 'calendar-check',
          component: 'HomePage',
          param: 2,
        },
        { title: 'My Contacts', icon: 'contacts', component: 'HomePage', param: 3 },*/
        /*{ title: 'Events', component: 'EventsPage' },
        { title: 'My Events', component: 'MyEventsPage' },
        { title: 'Tutorial', component: 'TutorialPage' },
        { title: 'Welcome', component: 'WelcomePage' },
        { title: 'Tabs', component: 'TabsPage' },
        { title: 'Cards', component: 'CardsPage' },
        { title: 'Content', component: 'ContentPage' },
        { title: 'Login', component: 'LoginPage' },
        { title: 'Signup', component: 'SignupPage' },
        { title: 'Master Detail', component: 'ListMasterPage' },
        { title: 'Menu', component: 'MenuPage' },
        { title: 'Settings', component: 'SettingsPage' },
        { title: 'Search', component: 'SearchPage' }*/
    ];

    constructor(
        private translate: TranslateService,
        public platform: Platform,
        settings: Settings,
        private config: Config,
        private statusBar: StatusBar,
        private splashScreen: SplashScreen,
        private user: User,
        private prizeGameProvider: PrizeGameProvider,
        private storage: Storage,
        private socketProvider: WebSocketProvider,
        public webPushProvider: WebPushProvider,
        public geoFenceProvider: GeoFenceProvider,
        public app: App,
        public events: Events,
        private deeplinks: Deeplinks,
        private eventInfoProvider: EventInfoProvider
    ) {
        events.subscribe('user:logout', () => {
            // this.rootPage = 'WelcomePage';
            console.log('not auth');
            this.logOut();
        });

        platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            if (platform.is("cordova")) {
                this.statusBar.styleLightContent();
                this.splashScreen.hide();

                // PUSH MOBILE RELATED NAVIGATION
                this.pages.push({
                  title: 'QR Reader',
                  icon: 'im-icon_qr',
                  component: 'QrCodeReaderPage',
                  param: '',
                  root: false
                })
            }

            platform.pause.subscribe(() => {
                window['paused'] = true;
                console.log('paused');
            });

            platform.resume.subscribe(() => {
                window['paused'] = false;
                console.log('resumed');
            });

            this.deeplinks.routeWithNavController(this.nav, {
                '/#/redirect/:response': RedirectPage
            }).subscribe((match) => {
                console.log('Successfully matched route: ' + JSON.stringify(match));
                const token = match.$link.fragment.split("redirect/")[1];
                console.log('Successfully matched route with token: ' + token);
                this.nav.setRoot(RedirectPage, {
                    response: token
                }).then(res => {
                    console.log("Redirected: " + res)
                });
            },
                (nomatch) => {
                    // nomatch.$link - the full link data
                    // console.error('Got a deeplink that didn\'t match', nomatch);
                });
        });
        platform.registerBackButtonAction(() => {
            // Catches the active view
            let navigation = this.app.getActiveNavs()[0];
            let activeView = navigation.getActive();
            let page = activeView ? navigation.getActive().instance : null;
            if (page && (page instanceof HomePage)) {
                if (navigation.canGoBack()) {
                    this.nav.pop();
                } else {
                    platform.exitApp();
                }
            } else if (page && !(page instanceof HomePage)) {
                const stack = this.nav.getViews();
                if (stack.length > 1) {
                    this.nav.pop();
                } else {
                    this.nav.setRoot('HomePage');
                }
            }
        });
        this.initTranslate();
    }

    initTranslate() {
        // Set the default language for translation strings, and the current language.
        this.translate.setDefaultLang('en');
        const browserLang = this.translate.getBrowserLang();

        if (browserLang) {
            if (browserLang === 'zh') {
                const browserCultureLang = this.translate.getBrowserCultureLang();

                if (browserCultureLang.match(/-CN|CHS|Hans/i)) {
                    this.translate.use('zh-cmn-Hans');
                } else if (browserCultureLang.match(/-TW|CHT|Hant/i)) {
                    this.translate.use('zh-cmn-Hant');
                }
            } else {
                this.translate.use(this.translate.getBrowserLang());
            }
        } else {
            this.translate.use('en'); // Set your language here
        }

        this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
            this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
        });
    }

    ngOnInit(): void {
        // this.storage.get('user').then(user => {
        //   if (user.sessionId) {
        //     console.log('Current user u app componenti', this.currentUser);
        //     this.webPushProvider.initialiseState();
        //     // console.log('Stigao sam ovdje');
        //     // this.socketProvider.initSocket(user.sessionId, this.currentUser.uuid);
        //     // this.socketProvider.checkSub();
        //   } else {
        //     // console.log('Nisam stigao ovdje');
        //   }
        // });
    }

    openPage(page) {
        // Reset the content nav to have just this page
        // we wouldn't want the back button to show in this scenario
        if (page.root) {
            this.nav.setRoot(page.component, {
                events: page.param,
            });
        } else {
            this.nav.push(page.component, {
                events: page.param,
            }).then(() => {
                const page = this.nav.getActive();
                const stack = this.nav.getViews();
                const duplicate = stack.filter(data => data.id === page.name && JSON.stringify(data.data) === JSON.stringify(page.data));
                if (duplicate.length === 2) {
                    this.nav.remove(duplicate[0].index);
                }
            });
        }

    }

    openProfile() {
        this.nav.push('ProfileSettingsPage');
    }

    prizeGameController() {
        this.nav.setRoot('PrizeGameControllerPage');
    }

    logOut() {
        this.user.logout().subscribe(() => {
            this.nav.setRoot('WelcomePage');
        });
        localStorage.clear();
    }

    get getCurrentUser(): CurrentUser {
        return this.user.currentUser();
    }

    loadCurrentUser() {
        this.currentUser = this.user.currentUser();
        this.user.loadCurrentUser().subscribe(res => {
            if (res) {
                this.user.setCurrentUser(res);
            }
        });
    }

    socialSignOut() { }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts